"use client";

import { ApiTechnologies } from "@/api/technologies";
import { useParams } from "next/navigation";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useTechnologyData = () => {
  const params = useParams();
  const { id } = params;

  const { data: detailTechnology, isLoading } = useLocalizedQuery({
    queryKey: ["technology", +id],
    queryFn: lang => ApiTechnologies.getDetailTechnology(+id, lang),
  });

  return { detailTechnology, isLoading };
};
